<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showDistrbutionPoint") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper" v-if="!loading">
      <div class="row">
        <!-- Start:: Distribution Point Data Section -->
        <h5 class="mt-5 font-weight-bold col-12">
          {{ $t("PLACEHOLDERS.distrbution_point_data") }}
        </h5>

        <!-- Start:: Avatar Image -->
        <div class="col-12 text-center my-4" v-if="data.avatar">
          <div class="avatar-preview">
            <img
              :src="data.avatar.url"
              :alt="data.name"
              style="max-width: 200px; max-height: 200px; border-radius: 10px; cursor: pointer;"
              @click="showImageModal(data.avatar.url)"
            />
            <p class="mt-2 text-muted">{{ $t("PLACEHOLDERS.user_image") }}</p>
          </div>
        </div>
        <!-- End:: Avatar Image -->

        <!-- Start:: Distribution Point Name Display -->
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.distrbution_point_name')"
          v-model="data.name"
          disabled
        />
        <!-- End:: Distribution Point Name Display -->

        <!-- Start:: Phone Display -->
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.phone')"
          v-model="data.mobile"
          disabled
        />
        <!-- End:: Phone Display -->

        <!-- Start:: Username Display -->
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.username')"
          v-model="data.distrbution_point_name"
          disabled
        />
        <!-- End:: Username Display -->

        <!-- Start:: Commercial Registration Number Display -->
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.commercial_registration_number')"
          v-model="data.commercial_registration_number"
          disabled
        />
        <!-- End:: Commercial Registration Number Display -->

        <!-- Start:: Join Date Display -->
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.join_date')"
          v-model="data.created_at"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.join_date')"
          v-model="data.created_at"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('STATISTICS.last_login_at')"
          v-model="data.last_login_at"
          disabled
        />
        <base-input
          col="6"
          type="text"
          :placeholder="$t('STATISTICS.login_count')"
          v-model="data.login_count"
          disabled
        />
        <!-- End:: Join Date Display -->

        <!-- Start:: Account Status Display -->
        <div class="col-12 my-3">
          <v-chip
            :color="data.is_active ? 'success' : 'error'"
            text-color="white"
            large
          >
            <v-icon left>
              {{ data.is_active ? 'mdi-check-circle' : 'mdi-close-circle' }}
            </v-icon>
            {{ data.is_active ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive') }}
          </v-chip>
        </div>
        <!-- End:: Account Status Display -->

        <!-- Start:: Location Section -->
        <hr class="mt-5 col-12" style="width: 98%" />
        <h5 class="my-5 font-weight-bold col-12">
          {{ $t("PLACEHOLDERS.location_on_map") }}
        </h5>

        <!-- Start:: Google Map -->
        <div class="col-12 mb-4">
          <MapComponent
            :lat="data.lat"
            :lng="data.lng"
          />
        </div>
        <!-- End:: Google Map -->
        <!-- End:: Location Section -->

        <!-- Start:: Statistics Section -->
        <!-- <hr class="mt-5 col-12" style="width: 98%" />
        <h5 class="my-5 font-weight-bold col-12">
          {{ $t("PLACEHOLDERS.parcel_statistics") }}
        </h5> -->

        <!-- Start:: Statistics Filter -->
        <!-- <div class="col-12 mb-4">
          <v-btn-toggle
            v-model="statisticsFilter"
            mandatory
            color="primary"
            @change="updateStatistics"
          >
            <v-btn value="daily">
              {{ $t("FILTERS.daily") }}
            </v-btn>
            <v-btn value="weekly">
              {{ $t("FILTERS.weekly") }}
            </v-btn>
            <v-btn value="monthly">
              {{ $t("FILTERS.monthly") }}
            </v-btn>
          </v-btn-toggle>
        </div> -->
        <!-- End:: Statistics Filter -->

        <!-- <div class="col-12">
          <v-row>
            <v-col cols="12" md="6">
              <v-card class="pa-4 mb-3">
                <div class="d-flex align-center">
                  <v-icon color="primary" large class="mr-3">mdi-login</v-icon>
                  <div>
                    <p class="text-muted mb-1">{{ $t("STATISTICS.login_count") }}</p>
                    <h3>{{ data.login_count || 0 }}</h3>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card class="pa-4 mb-3">
                <div class="d-flex align-center">
                  <v-icon color="info" large class="mr-3">mdi-clock-outline</v-icon>
                  <div>
                    <p class="text-muted mb-1">{{ $t("STATISTICS.last_login_at") }}</p>
                    <h4>{{ data.last_login_at || $t("TABLES.noData") }}</h4>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="pa-4 mb-3">
                <div class="d-flex align-center">
                  <v-icon color="orange" large class="mr-3">mdi-package-down</v-icon>
                  <div>
                    <p class="text-muted mb-1">{{ $t("PLACEHOLDERS.received_parcels") }}</p>
                    <h3>{{ statistics.received_parcels || 0 }}</h3>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="pa-4 mb-3">
                <div class="d-flex align-center">
                  <v-icon color="success" large class="mr-3">mdi-package-variant-closed</v-icon>
                  <div>
                    <p class="text-muted mb-1">{{ $t("PLACEHOLDERS.delivered_parcels") }}</p>
                    <h3>{{ statistics.delivered_parcels || 0 }}</h3>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="pa-4 mb-3">
                <div class="d-flex align-center">
                  <v-icon color="error" large class="mr-3">mdi-package-variant-closed-remove</v-icon>
                  <div>
                    <p class="text-muted mb-1">{{ $t("PLACEHOLDERS.returned_parcels") }}</p>
                    <h3>{{ statistics.returned_parcels || 0 }}</h3>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div> -->
        <!-- End:: Statistics Section -->
      </div>
    </div>

    <!-- Start:: Loading State -->
    <div v-else class="text-center py-5">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <!-- End:: Loading State -->

    <!-- Start:: Image Modal -->
    <v-dialog v-model="dialogImage" max-width="800">
      <v-card>
        <v-card-title class="headline">
          {{ $t("BUTTONS.show") }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogImage = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="text-center">
          <img :src="selectedImage" style="max-width: 100%; height: auto;" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End:: Image Modal -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MapComponent from "@/components/general/MapComponent.vue";

export default {
  name: "ShowDistrbutionPoint",

  components: {
    MapComponent,
  },

  data() {
    return {
      loading: false,
      dialogImage: false,
      selectedImage: null,
      showPassword: false,
      statisticsFilter: "daily",
      data: {
        name: null,
        distrbution_point_name: null,
        mobile: null,
        is_active: false,
        avatar: null,
        commercial_registration_number: null,
        lat: 24.7136,
        lng: 46.6753,
        login_count: 0,
        last_login_at: null,
        created_at: null,
        password: "********",
      },
      statistics: {
        received_parcels: 0,
        delivered_parcels: 0,
        returned_parcels: 0,
      },
    };
  },

  computed: {
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
  },

  methods: {
    // Show image in modal
    showImageModal(imageUrl) {
      this.selectedImage = imageUrl;
      this.dialogImage = true;
    },

    // Toggle password visibility
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    // Update statistics based on filter
    async updateStatistics() {
      // This method can be extended to fetch filtered statistics from API
      // For now, we'll use the same data
      // You can add API call here with filter parameter
      console.log("Filter changed to:", this.statisticsFilter);
    },

    // Fetch distribution point data
    async getDistrbutionPointData() {
      this.loading = true;
      try {
        const res = await this.$axios.get(
          `distrbution-points/${this.$route.params.id}`
        );
        const point = res.data.data;

        // Populate data
        this.data.name = point.name;
        this.data.distrbution_point_name = point.distrbution_point_name;
        this.data.mobile = point.mobile;
        this.data.is_active = point.is_active;
        this.data.commercial_registration_number = point.commercial_registration_number;
        this.data.lat = point.lat || 24.7136;
        this.data.lng = point.lng || 46.6753;
        this.data.avatar = point.avatar;
        this.data.login_count = point.login_count || 0;
        this.data.last_login_at = point.last_login_at;
        this.data.created_at = point.created_at;

        // Statistics - These would come from API with filter
        // For now using placeholder values
        // this.statistics.received_parcels = point.received_parcels || 0;
        // this.statistics.delivered_parcels = point.delivered_parcels || 0;
        // this.statistics.returned_parcels = point.returned_parcels || 0;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$message.error(error.response?.data?.message || this.$t("MESSAGES.error"));
        this.$router.push("/DistrbutionPoints/all");
      }
    },
  },

  created() {
    // Fetch distribution point data on component creation
    this.getDistrbutionPointData();
  },
};
</script>

<style scoped>
.avatar-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.v-card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
